import { WebSocketInteraction } from '../network-logs/ocppNetworkLogsDto';
import { CommunicationDirectionModel } from '../network-logs/ocppNetworkLogsModel';

export const communicationDirectionNormalizer = (
  messageDirection: WebSocketInteraction
): CommunicationDirectionModel => {
  return communicationDirectionMap[messageDirection];
};

export const communicationDirectionMap: Record<
  WebSocketInteraction,
  CommunicationDirectionModel
> = {
  CS_CSMS: 'chargingStationToCsms',
  CSMS_CS: 'csmsToChargingStation',
};

export const communicationDirectionToEnum: Record<
  CommunicationDirectionModel,
  WebSocketInteraction
> = {
  chargingStationToCsms: 'CS_CSMS',
  csmsToChargingStation: 'CSMS_CS',
};
